export const MAX_CHECKBOXES_WHILE_COLLAPSED = 6
